import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AcvisService } from '@app/services/acvis.service';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';

@Component({
    selector: 'clever-mietzeit',
    templateUrl: './mietzeit.component.html',
    styleUrls: ['./mietzeit.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class MietzeitComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() title: string;
    @Input() isFrom: boolean;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    media: string = 'lg';
    origin = 'default';
    mySearchControl: string = 'Alle';
    tmp_mySearchControl: string = 'Alle';

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected acvisService: AcvisService,
        protected render: Renderer2,
        protected carrentFilterSertvice: CarrentFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
            this.initMedia();
        }
    }

    initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openModal(ev) {
        this.tmp_mySearchControl = this.mySearchControl;
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev) {
        this.tmp_mySearchControl = this.mySearchControl;
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal() {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    sendSelect() {
        if (this.mySearchControl !== 'Alle' && this.tmp_mySearchControl !== this.mySearchControl) {
            if (this.isFrom) {
                this.carrentFilterSertvice.carrentstartTime(this.mySearchControl, this.mode !== 'home');
            } else if (!this.isFrom) {
                this.carrentFilterSertvice.carrentendTime(this.mySearchControl, this.mode !== 'home');
            }
        }
        this.closeModal();
    }

    zoomin(position: any) {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    initFilterSub(): void {
        this.carrentFilterSertvice.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: CarrentFilters) => {
            if (filter.startTime?.length > 0 && this.isFrom) {
                this.mySearchControl = filter.startTime;
            } else if (filter.endTime?.length > 0 && !this.isFrom) {
                this.mySearchControl = filter.endTime;
            } else {
                this.mySearchControl = 'Alle';
            }
            this.cdr.detectChanges();
        });
    }
}
